function getSelectedVariationAttributes(componentId, productId, variationId) {
  try {
    const selections = collectSelectionsFromStateOrDOM();
    const hash = selectionHash(selections);
    const cacheKey = `${Number(componentId)}:${Number(productId)}:${hash}`;
    const list = VAR_CACHE.get(cacheKey);

    if (Array.isArray(list) && list.length) {
        const found = list.find(v => Number(v.variation_id) === Number(variationId));
        if (found && found.attributes && typeof found.attributes === 'object') {
            return { ...found.attributes };
        }
    }

    const comp = (STATE.data?.components || []).find(c => Number(c.id) === Number(componentId));
    if (comp) {
        const prod = (comp.products || []).find(p => Number(p.product_id) === Number(productId));
        if (prod && Array.isArray(prod.variations)) {
            const found2 = prod.variations.find(v => Number(v.variation_id) === Number(variationId));
            if (found2 && found2.attributes && typeof found2.attributes === 'object') {
                return { ...found2.attributes };
            }
        }
    }
  } catch (e) {
  }
  return undefined;
}


function collectSelectionsFor(componentId) {
  const ids = new Set(upstreamComponentIds(componentId));
  const all = collectSelectionsFromStateOrDOM();
  const filtered = {};
  Object.keys(all).forEach(k => {
      const cid = Number(k.split(':')[0] || k);
      if (ids.has(cid)) filtered[k] = all[k];
  });
  return filtered;
}

const NARROW_CACHE = new Set();
const narrowKey = (componentId) =>
  `${Number(componentId)}:${selectionHash(collectSelectionsFor(componentId))}`;


const selectionHash = (obj) => {
  try { return btoa(unescape(encodeURIComponent(JSON.stringify(obj || {})))); }
  catch { return String(Date.now()); }
};

function invalidateDownstreamFrom(componentId) {
  const order = COMPONENT_ORDER();
  const idx = order.indexOf(Number(componentId));
  const downstream = idx < 0 ? [] : order.slice(idx + 1);

  for (const did of downstream) {
  }
  const old = Array.from(NARROW_CACHE);
  NARROW_CACHE.clear();
  for (const k of old) {
      const keep = !downstream.some(did => k.startsWith(`${Number(did)}:`));
      if (keep) NARROW_CACHE.add(k);
  }

  downstream.forEach(did => {
      clearSelectionForComponent(did);
      clearRenderedOptionsForComponent?.(did);
  });
}